import React from "react";
import "./Featured.css";
import * as helpers from "../helpers";
import * as gnhelpers from "../../gatsby-node-helpers";

export const FooterFeaturedLocationsSingleLink = React.memo(
  ({ data, i18n }) => {
    /**
     * NOTE!
     * here, the configData was consumed from context, not from useConfigData hook
     * need to decide
     * assumption (wrong!) is that context will reduce the number of queries >> build time
     * however, attempt to completely get rid of hooks caused loading times to get larger due to large context
     * (what was attempted is to query all pages in gatsby-node phase and pass this data inside context
     * problem was that as it rendered on client, each component had huge context)
     *
     * update 2025-02-26: large context object results in slowing build times
     */
    const url_slug = data.node.frontmatter.url_slug;

    const main_item_translated =
      data.node.frontmatter[`main_item_translated_${i18n?.i18n_current}`] ?? "";

    const seo_meta_description =
      data.node.frontmatter[`seo_meta_description_${i18n?.i18n_current}`] ?? "";

    const main_item_featured_title = main_item_translated;

    // const _ARTICLES = process.env.GATSBY_URL_SLUG_CLOUDFRONT;
    const ARTICLES = gnhelpers.getUrlSlugByDomainBuildCode(
      data.node.frontmatter.domain
    );
    const paperClassByBuildCode = !helpers.isWhiteLabelDomain(
      process.env.GATSBY_NODE_BUILD_CODE_BY_DOMAIN
    )
      ? "paper"
      : "paper-aca";

    return (
      <div
        id={`footer-featured-main-item-single-${url_slug}`}
        className={`footer-featured-main-item-single-link ${paperClassByBuildCode}`}
        key={url_slug}
        title={seo_meta_description}
      >
        <a
          href={`/${
            i18n?.i18n_current !== i18n?.i18n_main
              ? i18n?.i18n_current + "/"
              : ""
          }${ARTICLES}/${url_slug}`}
          className="anchor-featured"
          aria-label={`link to article meta description: ${seo_meta_description}`}
        >
          {main_item_featured_title}
        </a>
      </div>
    );
  }
);
